module.exports = __webpack_public_path__ + "img/sample-medicare-card-part-a.001d087.png";